<template>
  <div>
    <SignupForm :fromPage="fromPage"></SignupForm>
  </div>
</template>

<script>
import SignupForm from '@/components/SignupComps/SignupForm.vue';

export default {
  name: "Signup",
  components: {
    SignupForm
  },
  data() {
    return {
      fromPage: null
    }
  },
  created() {
    // 获取来源页面参数
    this.fromPage = this.$route.query.from || null;
  }
};
</script>

<style lang="scss" scoped>
// 页面样式可以在这里添加
</style>
